import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import DateRangeInput from "../../../components/DateRangeInput";
import {
  DIRECTION_OPTIONS,
} from "./emailFormatters";

const fieldSx = { minWidth: 132 };
const controlSx = {
  m: 0,
  "& .MuiInputBase-root": {
    height: 40,
  },
};
const dateInputSx = {
  width: 148,
  m: 0,
  "& .MuiInputBase-root": {
    height: 40,
  },
};
const placeholderColor = "#9e9e9e";

const EmailFilters = ({ filters, today, onChange, onClear, onSendTestEmail, canSendTestEmail, patientControl }) => {
  const [draft, setDraft] = useState(filters);
  const [dateError, setDateError] = useState("");

  useEffect(() => {
    setDraft(filters);
  }, [filters]);

  const validateDates = (nextDraft = draft) => {
    if (nextDraft.dateFrom && nextDraft.dateFrom > today) {
      setDateError("From must be today or earlier.");
      return false;
    }
    if (nextDraft.dateFrom && nextDraft.dateTo && nextDraft.dateFrom > nextDraft.dateTo) {
      setDateError("From cannot be after To.");
      return false;
    }
    setDateError("");
    return true;
  };

  const updateDateField = (field) => (event) => {
    const nextDraft = { ...draft, [field]: event.target.value || "" };
    setDraft(nextDraft);
    validateDates(nextDraft);
  };

  const updateAndSearch = (field) => (event) => {
    const nextDraft = { ...draft, [field]: event.target.value };
    setDraft(nextDraft);
    if (validateDates(nextDraft)) {
      onChange(nextDraft);
    }
  };

  const handleSearch = () => {
    if (!validateDates(draft)) return;
    onChange(draft);
  };

  const handleClear = () => {
    setDateError("");
    onClear();
  };

  return (
    <Box>
      <Stack
        direction="row"
        spacing={1}
        useFlexGap
        flexWrap="wrap"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          rowGap: 1,
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          flexWrap="wrap"
          alignItems="center"
          sx={{ flex: "1 1 640px", minWidth: 0, rowGap: 1 }}
        >
          {patientControl}
          <FormControl size="small" sx={{ ...fieldSx, ...controlSx }}>
            <Select
              displayEmpty
              value={draft.direction || ""}
              onChange={updateAndSearch("direction")}
              renderValue={(selected) => {
                if (!selected) return <span style={{ color: placeholderColor }}>Direction</span>;
                return selected;
              }}
            >
              <MenuItem value=""><em>CLEAR SELECTION</em></MenuItem>
              {DIRECTION_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>{option}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <DateRangeInput
            fromValue={draft.dateFrom}
            toValue={draft.dateTo}
            onFromChange={updateDateField("dateFrom")}
            onToChange={updateDateField("dateTo")}
            error={dateError}
            inputSx={dateInputSx}
          />
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          useFlexGap
          flexWrap="wrap"
          alignItems="center"
          justifyContent="flex-end"
          sx={{ flex: "0 1 auto", ml: "auto", rowGap: 1 }}
        >
          <Button variant="outlined" onClick={handleClear}>
            Clear
          </Button>
          <Button variant="contained" onClick={handleSearch}>
            Search
          </Button>
          {canSendTestEmail && (
            <Button variant="contained" onClick={onSendTestEmail} sx={{ whiteSpace: "nowrap" }}>
              Test
            </Button>
          )}
        </Stack>
      </Stack>
      {dateError && (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5, lineHeight: 1.2 }}>
          {dateError}
        </Typography>
      )}
    </Box>
  );
};

export default EmailFilters;
